import React from 'react';
import './ThankYou.css';
import logo from '../assets/logo.png';
import avatar1 from '../assets/avatar1.png';
import avatar2 from '../assets/avatar2.png';
import avatar3 from '../assets/avatar3.png';

function ThankYou() {
  return (
    <div className="thank-you-page">
      <header className="nav-header">
        <div className="logo">
          <a style={{textDecoration: 'none'}} href="../">
            <h1>LeasEiZi</h1>
          </a>
        </div>
      </header>

      <main className="content-wrapper">
        <img src={logo} alt="LeasEiZi Logo" className="logo-large" />
        <h1 className="thank-you-title">Thank you for choosing LeasEiZi</h1>
        <p className="confirmation-text">We received the apartment information<br />and our system will begin to track<br />the lease prices for the apartment daily!</p>

        <div className="email-notice">
          <p>Look out for emails from <a href="mailto:info@leaseizi.com" className="email-link">info@leaseizi.com</a>.</p>
          <p>Make sure to watch out for our Price Alerts!</p>
        </div>

        <h2>See what our amazing early adopters have to say about us!</h2>

        <div className="testimonials">
          <div className="testimonial-card">
            <div className="testimonial-header">
              <img src={avatar1} alt="Avatar" className="testimonial-avatar" />
              <div className="testimonial-info">
                <h3>Delighted User</h3>
                <p>LeasEiZi.com</p>
              </div>
            </div>
            <p className="testimonial-text">Thank you for building such an empowering tool, especially for budgeters and deal lovers. LeasEiZi did all the hard work for me!</p>
          </div>

          <div className="testimonial-card">
            <div className="testimonial-header">
              <img src={avatar2} alt="Avatar" className="testimonial-avatar" />
              <div className="testimonial-info">
                <h3>Customer Feedback</h3>
                <p>LeasEiZi.com</p>
              </div>
            </div>
            <p className="testimonial-text">LeasEiZi helped me track apartment lease prices with ease, I saved thousands of dollars a year! Get the best deal with LeasEiZi!</p>
          </div>

          <div className="testimonial-card">
            <div className="testimonial-header">
              <img src={avatar3} alt="Avatar" className="testimonial-avatar" />
              <div className="testimonial-info">
                <h3>Thrilled User</h3>
                <p>LeasEiZi.com</p>
              </div>
            </div>
            <p className="testimonial-text">LeasEiZi goes above and beyond, they provide resources for everything related to apartment leasing and tips to save a bit more each month!</p>
          </div>
        </div>

        <div className="support-buttons">
          <a href="https://www.buymeacoffee.com/LeasEizi" className="support-btn" target="_blank" rel="noopener noreferrer">Buy Us A Pizza 🍕</a>
          <a href="https://pay.leaseizi.com/" className="support-btn" target="_blank" rel="noopener noreferrer">Support LeasEiZi</a>
        </div>
      </main>

      <footer>
        <p>LeasEiZi.com</p>
        <p>Copyright 2026</p>
      </footer>
    </div>
  );
}

export default ThankYou;
